import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Card,
  CardContent,
  Chip
} from "@mui/material";
import { get_admin_users, get_admin_stats } from "../Api service/APIvariables";
import CustomPagination from "./CustomPagination";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState({
    total_users: 0,
    total_pro_users: 0,
    total_cards_scanned: 0,
    total_emails_sent: 0
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) return;

      const formData = new FormData();
      formData.append("user_id", user_id);

      // Fetch Stats
      const statsRes = await fetch(get_admin_stats, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const statsData = await statsRes.json();
      if (!statsData.error) {
        setStats(statsData.data);
      }

      // Fetch Users
      const usersRes = await fetch(get_admin_users, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const usersData = await usersRes.json();
      if (!usersData.error) {
        const processed = usersData.data.reverse().map((row, index) => ({
          ...row,
          generatedId: index + 1
        }));
        setUsers(processed);
      }
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    window.addEventListener("planUpdated", fetchData);
    return () => window.removeEventListener("planUpdated", fetchData);
  }, []);

  return (
    <Box sx={{ padding: 4, width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 4, color: "#453c72" }}>
        Internal Ops Dashboard (Read Only)
      </Typography>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>Total Users</Typography>
              <Typography variant="h4">{stats.total_users}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>Pro Users</Typography>
              <Typography variant="h4" sx={{ color: "#00897B" }}>{stats.total_pro_users}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>Cards Scanned</Typography>
              <Typography variant="h4">{stats.total_cards_scanned}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>Emails Sent (Today)</Typography>
              <Typography variant="h4">{stats.total_emails_sent}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Users Table */}
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#453c72" }}>
        User Roster & Limits
      </Typography>
      <TableContainer component={Paper} elevation={2}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell><strong>No.</strong></TableCell>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Company</strong></TableCell>
              <TableCell align="center"><strong>Status</strong></TableCell>
              <TableCell align="center"><strong>Cards (Today)</strong></TableCell>
              <TableCell align="center"><strong>Emails (Today)</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
              <TableRow key={row.generatedId}>
                <TableCell>{row.generatedId}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.company_name}</TableCell>
                <TableCell align="center">
                  <Box sx={{
                    display: 'inline-block',
                    px: 1.5, py: 0.5,
                    borderRadius: 1,
                    backgroundColor: row.plan_name === 'Pro' ? '#e1bee7' : 
                                     row.plan_name === 'Plus' ? '#bbdefb' : 
                                     row.plan_name === 'Unlimited' ? '#fff9c4' : '#f5f5f5',
                    color: row.plan_name === 'Pro' ? '#6a1b9a' : 
                           row.plan_name === 'Plus' ? '#1565c0' : 
                           row.plan_name === 'Unlimited' ? '#f57f17' : '#616161',
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    letterSpacing: 0.5
                  }}>
                    {row.plan_name ? row.plan_name.toUpperCase() : 'FREE'}
                  </Box>
                </TableCell>
                <TableCell align="center">{row.cards_today}</TableCell>
                <TableCell align="center">{row.emails_today}</TableCell>
              </TableRow>
            ))}
            {users.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">No users found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "16px",
          marginRight: "auto",
        }}
      >
        <CustomPagination
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: "12px",
            width: "auto",
            justifyContent: "space-between",
            marginBottom: 2,
          }}
        />
      </div>
    </Box>
  );
}
